import {
  Search,
  MousePointerClick,
  Share2,
  PenTool,
  Code2,
  BarChart3,
  Cloud,
  ShoppingBag,
  HeartPulse,
  Landmark,
  Building2,
  GraduationCap,
  Plane,
  Factory,
} from "lucide-react";

export const IMAGES = {
  team: "https://images.unsplash.com/photo-1787647561979-da6797612e4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbSUyMGNyZWF0aXZpdHklMjBvZmZpY2V8ZW58MHx8fHwxNzg5MTIyNTIzfDA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1787647560610-435c393752ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHxfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbSUyMGNyZWF0aXZpdHklMjBvZmZpY2V8ZW58MHx8fHwxNzg5MTIyNTIzfDA&ixlib=rb-4.1.0&q=85",
  workspace: "https://images.unsplash.com/photo-1787647562031-aedbc5ab7d05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5JTIwdGVhbSUyMGNyZWF0aXZpdHklMjBvZmZpY2V8ZW58MHx8fHwxNzg5MTIyNTIzfDA&ixlib=rb-4.1.0&q=85",
  neon: "https://images.unsplash.com/photo-1759074558477-6f35e3a5eb30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MTJ8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjAzZCUyMG5lb24lMjBnZW9tZXRyeSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4OTEyMjUyM3ww&ixlib=rb-4.1.0&q=85",
  shapes: "https://images.unsplash.com/photo-1783191250657-e5f7a17ea465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MTJ8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjAzZCUyMG5lb24lMjBnZW9tZXRyeSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4OTEyMjUyM3ww&ixlib=rb-4.1.0&q=85",
};

export const ENTITIES = [
  {
    key: "india",
    name: "Vigarbiz ITES Pvt Ltd",
    region: "India — Global Delivery & Tech Operations",
    address: "2nd Floor, Office No. 13, A Wing, City Vista, Ashoka Nagar, Kharadi, Pune 411014",
    email: "hello@vigarbizinc.com",
    phones: ["+91 90674 05531", "+91 96370 49033"],
    timeZone: "Asia/Kolkata",
    city: "Pune",
  },
  {
    key: "us",
    name: "Vigarbiz Inc",
    region: "United States — Global Strategy & Client HQ",
    address: "42618 Fontainebleau Park Ln, Fremont, CA",
    email: "hello@vigarbizinc.com",
    phones: ["+1 530 518 1420"],
    timeZone: "America/Los_Angeles",
    city: "Fremont",
  },
];

export const MARQUEE_ITEMS = [
  "Search Dominance",
  "Paid Velocity",
  "Brand Gravity",
  "Content That Converts",
  "Full-Funnel Analytics",
  "Web Experiences",
  "Social Firepower",
  "Growth Engineering",
];

export const STATS = [
  { value: "312%", label: "Average ROAS uplift" },
  { value: "9.4M", label: "Impressions per month" },
  { value: "120+", label: "Brands scaled" },
  { value: "2", label: "Global delivery hubs" },
];

export const SERVICES = [
  {
    id: "seo",
    num: "01",
    icon: Search,
    title: "SEO & Organic Growth",
    tagline: "Own page one before your competitors wake up.",
    description:
      "Technical audits, programmatic page systems, digital PR and authority engineering. We build organic moats that compound month after month — not rented rankings that vanish when spend stops.",
    deliverables: ["Technical SEO audit", "Programmatic page systems", "Digital PR & backlinks", "Content clusters", "Local & international SEO"],
    kpis: [
      { label: "Organic sessions", delta: "+186%", value: 86 },
      { label: "Keyword coverage", delta: "+4.2x", value: 78 },
      { label: "Cost per acquisition", delta: "−41%", value: 64 },
    ],
  },
  {
    id: "paid",
    num: "02",
    icon: MousePointerClick,
    title: "Paid Media & Performance",
    tagline: "Every dollar accountable. Every click engineered.",
    description:
      "Google, Meta, LinkedIn and programmatic buys run as one portfolio. Creative testing at velocity, budget shifts in hours not weeks, and reporting your CFO will actually read.",
    deliverables: ["Full-funnel media planning", "Google & Meta Ads", "LinkedIn ABM campaigns", "Creative testing sprints", "Landing page CRO"],
    kpis: [
      { label: "Return on ad spend", delta: "+312%", value: 92 },
      { label: "Click-through rate", delta: "4.8%", value: 71 },
      { label: "Wasted spend", delta: "−38%", value: 66 },
    ],
  },
  {
    id: "social",
    num: "03",
    icon: Share2,
    title: "Social Media & Community",
    tagline: "Feeds are rented. Communities are owned.",
    description:
      "Platform-native content systems, creator partnerships and community ops that turn passive scrollers into an audience that shows up, shares and buys.",
    deliverables: ["Channel strategy", "Short-form video systems", "Creator & influencer programs", "Community management", "Social listening"],
    kpis: [
      { label: "Engagement rate", delta: "+240%", value: 82 },
      { label: "Audience growth", delta: "+96k", value: 74 },
      { label: "Response time", delta: "<2h", value: 88 },
    ],
  },
  {
    id: "content",
    num: "04",
    icon: PenTool,
    title: "Content & Creative Studio",
    tagline: "Stories with a spreadsheet behind them.",
    description:
      "Editorial, design and motion built by people who read the performance dashboard before they open the brief. Content that ranks, converts and gets remembered.",
    deliverables: ["Brand messaging", "Long-form editorial", "Motion & video", "Ad creative at scale", "Sales enablement assets"],
    kpis: [
      { label: "Content-attributed pipeline", delta: "+57%", value: 69 },
      { label: "Avg. time on page", delta: "+2.1x", value: 76 },
      { label: "Creative output", delta: "120 assets/mo", value: 90 },
    ],
  },
  {
    id: "web",
    num: "05",
    icon: Code2,
    title: "Web & Product Engineering",
    tagline: "Sites that load fast and sell faster.",
    description:
      "Conversion-first websites, landing systems and product interfaces. React-grade engineering from our Hyderabad studio, designed to turn traffic into revenue.",
    deliverables: ["Marketing sites", "Landing page systems", "E-commerce builds", "Web apps & dashboards", "Performance optimization"],
    kpis: [
      { label: "Conversion rate", delta: "+94%", value: 84 },
      { label: "Core Web Vitals", delta: "95+", value: 95 },
      { label: "Bounce rate", delta: "−33%", value: 62 },
    ],
  },
  {
    id: "analytics",
    num: "06",
    icon: BarChart3,
    title: "Analytics & CRO",
    tagline: "If it can't be measured, we don't ship it.",
    description:
      "Server-side tracking, attribution modeling and experimentation programs that tell you exactly which rupee or dollar produced which result.",
    deliverables: ["GA4 & server-side tagging", "Attribution modeling", "A/B testing programs", "Executive dashboards", "Funnel analysis"],
    kpis: [
      { label: "Tracking accuracy", delta: "98.2%", value: 98 },
      { label: "Experiments per quarter", delta: "24+", value: 80 },
      { label: "Funnel uplift", delta: "+47%", value: 73 },
    ],
  },
];

export const INDUSTRIES = [
  { id: "saas", icon: Cloud, title: "SaaS & Software", tags: ["B2B", "Enterprise"], desc: "Pipeline-first demand engines, PLG funnels and ABM programs for product-led and sales-led teams." },
  { id: "ecom", icon: ShoppingBag, title: "E-commerce & Retail", tags: ["B2C", "D2C"], desc: "Full-funnel acquisition, retention loops and creative systems built for basket size and repeat rate." },
  { id: "health", icon: HeartPulse, title: "Healthcare & Wellness", tags: ["B2C"], desc: "Compliant, trust-first marketing for clinics, healthtech and wellness brands that can't afford to overclaim." },
  { id: "fintech", icon: Landmark, title: "Fintech & Banking", tags: ["B2B", "Enterprise"], desc: "Growth under regulation — precision targeting, education-led content and airtight analytics." },
  { id: "realestate", icon: Building2, title: "Real Estate", tags: ["B2C"], desc: "Hyperlocal search dominance, lead nurture journeys and site-visit pipelines for developers and brokers." },
  { id: "education", icon: GraduationCap, title: "Education & EdTech", tags: ["B2C", "B2B"], desc: "Enrollment engines that fill cohorts — from search capture to counselor-assist automation." },
  { id: "hospitality", icon: Plane, title: "Hospitality & Travel", tags: ["B2C"], desc: "Direct-booking strategies that cut OTA commissions and turn guests into repeat advocates." },
  { id: "manufacturing", icon: Factory, title: "Manufacturing & Logistics", tags: ["B2B", "Enterprise"], desc: "Long-cycle B2B demand generation, distributor enablement and RFQ-driving digital presence." },
];

export const MANIFESTO = [
  { num: "01", title: "Strategy", body: "Every rupee and every dollar is mapped to an outcome before a single ad ships. We start with your P&L, not our playbook — positioning, audience math and channel economics first." },
  { num: "02", title: "Execution", body: "Sprints, not decks. Work ships weekly: campaigns live, pages deployed, creatives tested. Our Hyderabad studio and San Francisco strategy desk run as one team across time zones." },
  { num: "03", title: "Velocity", body: "Speed compounds. We run more experiments in a quarter than most agencies run in a year, and we kill losers fast so winners get the budget they deserve." },
  { num: "04", title: "Scale", body: "From the first click to a global funnel, we build systems — not one-off campaigns — that keep performing as you grow from city to country to continent." },
];

export const JOBS = [
  {
    id: "performance-marketing-manager",
    dept: "Growth",
    title: "Performance Marketing Manager",
    location: "Pune, India",
    type: "Full-time",
    summary: "Own seven-figure monthly budgets across Google and Meta for US and Indian clients.",
    responsibilities: ["Plan and run full-funnel paid campaigns", "Lead weekly creative testing sprints", "Report ROAS and CAC to client leadership", "Mentor two junior media buyers"],
  },
  {
    id: "senior-seo-strategist",
    dept: "Organic",
    title: "Senior SEO Strategist",
    location: "Remote (India)",
    type: "Full-time",
    summary: "Architect programmatic SEO systems and authority programs for SaaS and e-commerce brands.",
    responsibilities: ["Own technical and content roadmaps for 4-6 clients", "Build programmatic page frameworks", "Run digital PR and link acquisition", "Present quarterly growth reviews"],
  },
  {
    id: "content-strategist",
    dept: "Creative",
    title: "Content Strategist",
    location: "Pune, India",
    type: "Full-time",
    summary: "Turn performance data into editorial that ranks, converts and gets remembered.",
    responsibilities: ["Own content calendars across 3 verticals", "Brief and edit writers and designers", "Tie every asset to a funnel metric", "Run content refresh programs"],
  },
  {
    id: "full-stack-engineer",
    dept: "Engineering",
    title: "Full-Stack Engineer (React / Python)",
    location: "Pune, India",
    type: "Full-time",
    summary: "Build conversion-first marketing sites and internal tooling for the growth team.",
    responsibilities: ["Ship React marketing sites and landing systems", "Build FastAPI services and integrations", "Obsess over Core Web Vitals", "Prototype experiments with the CRO team"],
  },
  {
    id: "client-partner",
    dept: "Client Services",
    title: "Client Partner / Account Manager",
    location: "Fremont, USA",
    type: "Full-time",
    summary: "Be the strategic face of Vigarbiz for our US portfolio — from quarterly planning to renewal.",
    responsibilities: ["Own 6-8 client relationships end-to-end", "Translate business goals into growth roadmaps", "Lead QBRs with founders and CMOs", "Spot expansion opportunities across services"],
  },
];

export const POSTS = [
  {
    slug: "death-of-last-click",
    title: "The Death of Last-Click: Measurement in a Privacy-First Web",
    tag: "Analytics",
    date: "Jun 2026",
    readTime: "7 min",
    cover: IMAGES.neon,
    excerpt: "Attribution didn't get harder — it got honest. Here's the measurement stack we deploy when cookies crumble.",
    body: [
      "Last-click attribution was always a comforting lie. It told you the final touchpoint did all the work, the way a scoreboard tells you the striker won the match. Privacy regulation, browser tracking prevention and walled gardens didn't break measurement — they exposed how lazy it had become.",
      "The replacement stack has three layers. First, server-side tagging so your own data pipeline is resilient to browser restrictions. Second, media mix modeling for the channels that resist user-level tracking. Third — and most underrated — disciplined incrementality testing: geo holdouts and conversion lift studies that answer the only question that matters, 'what would have happened anyway?'",
      "None of this requires a data science team. It requires deciding that directional truth beats precise fiction. Our clients who made this shift reallocated an average of 22% of spend within two quarters — and every one of them wondered why they waited.",
    ],
  },
  {
    slug: "programmatic-seo-at-scale",
    title: "Programmatic SEO at Scale: 40,000 Pages, One Framework",
    tag: "SEO",
    date: "May 2026",
    readTime: "9 min",
    cover: IMAGES.shapes,
    excerpt: "How we build templated page systems that capture long-tail demand without triggering a single quality flag.",
    body: [
      "Programmatic SEO has a reputation problem because most of it is spam with extra steps. The difference between a doorway-page graveyard and a durable organic asset is one thing: each page must answer a real query better than anything else on the internet for that query.",
      "Our framework starts with demand mapping — clustering thousands of long-tail queries by intent, not just keyword. Then a data layer: what unique information can we serve per page that no competitor has? Inventory, pricing, comparisons, locality, regulations. If the answer is 'nothing unique', we don't build the template.",
      "The result for one e-commerce client: 40,000 indexed pages, 1.9M monthly organic sessions, and a content cost per visit 94% below their paid equivalent. Scale works when quality is the constraint, not the casualty.",
    ],
  },
  {
    slug: "creative-fatigue",
    title: "Creative Fatigue Is a Media Problem",
    tag: "Paid Media",
    date: "May 2026",
    readTime: "5 min",
    cover: IMAGES.workspace,
    excerpt: "Your ads aren't burning out because your designers are slow. They're burning out because your testing system is.",
    body: [
      "When performance dips, the reflex is to blame creative. But watch the data closely and a different story emerges: winning ads decay on a predictable curve, and most accounts simply have no pipeline ready to replace them. Fatigue is a supply-chain failure.",
      "The fix is a testing cadence, not a bigger design team. We run structured sprints: every week, new hooks enter rotation against the reigning champion. Every concept is a hypothesis — about the audience, the objection, the moment of desire — so even losers teach us something that feeds the next round.",
      "Accounts on this system don't avoid fatigue; they metabolize it. Blended ROAS stops swinging with creative luck and starts compounding with creative knowledge. That's the difference between an ad account and a learning machine.",
    ],
  },
  {
    slug: "brand-gravity",
    title: "Brand Gravity: Why Performance Needs Story",
    tag: "Brand",
    date: "Apr 2026",
    readTime: "6 min",
    cover: IMAGES.team,
    excerpt: "The cheapest click is the one people were already looking for. Brand is a performance channel — treat it like one.",
    body: [
      "There's a moment in every scaling journey where paid efficiency flatlines. Audiences saturate, CPMs climb, and the spreadsheet says 'spend more to stand still'. The brands that break through this ceiling share one trait: people search for them by name.",
      "Branded search is the cheapest, highest-converting traffic that exists — and it's manufactured entirely upstream by story, consistency and memory. Yet most performance teams treat brand spend as unmeasurable indulgence while celebrating a 4% CTR like it's alchemy.",
      "We measure brand gravity directly: share of search, direct traffic trend, branded query volume as a leading indicator of next quarter's CAC. When those numbers move, everything downstream gets cheaper. Brand isn't the alternative to performance. It's the multiplier.",
    ],
  },
  {
    slug: "ai-in-the-agency-workflow",
    title: "AI in the Agency Workflow: Augment, Don't Automate",
    tag: "AI",
    date: "Mar 2026",
    readTime: "8 min",
    cover: IMAGES.neon,
    excerpt: "We use AI every day — just never where judgment lives. An honest map of what machines do in our studio.",
    body: [
      "Every agency now claims to be 'AI-powered', which usually means they fired the junior copywriters and hoped nobody would notice. Our rule is simpler: AI touches volume, humans own judgment. The moment a decision affects positioning, spend or a client's reputation, a person makes it.",
      "In practice: AI drafts fifty hook variations, a strategist picks three and rewrites two. AI clusters ten thousand search queries overnight, a human decides which clusters deserve a page. AI flags anomalies in the data pipeline at 3am, a human decides what they mean in the morning.",
      "This division of labor is why our output tripled without headcount growth — and why quality went up, not down. The agencies that will struggle aren't the ones using too little AI. They're the ones who automated the thinking and kept the typing.",
    ],
  },
  {
    slug: "content-compounding-playbook",
    title: "The 90-Day Content Compounding Playbook",
    tag: "Content",
    date: "Feb 2026",
    readTime: "6 min",
    cover: IMAGES.office,
    excerpt: "Content doesn't fail from lack of quality. It fails from lack of system. The exact 90-day cadence we run.",
    body: [
      "Most content programs die of randomness: a burst of enthusiasm, ten posts, silence. Compounding requires the opposite — a boring, relentless cadence where every asset has a job, a distribution plan and a refresh date.",
      "Days 1-30: build the spine. Four pillar pieces targeting your highest-value clusters, each engineered for search and sales enablement simultaneously. Days 31-60: atomize. Every pillar becomes clips, carousels, newsletter sections and sales one-pagers. Days 61-90: refresh and interlink. Update winners, prune losers, wire the cluster together so authority flows.",
      "By day 90 you don't have 40 random posts — you have a system where each asset makes the others more valuable. That's the difference between publishing and compounding, and it's entirely a process decision, not a talent one.",
    ],
  },
];

export const BUDGET_OPTIONS = ["$5k – $10k / month", "$10k – $25k / month", "$25k – $50k / month", "$50k+ / month", "One-time project"];

export const CLIENT_WORDMARKS = ["KARTIFY", "NOVABYTE", "MEDINEST", "FINCHPAY", "URBANNEST", "LEARNLOOP", "VELORA", "TRAILBYTE"];

export const CASE_STUDIES = [
  {
    client: "Kartify",
    industry: "D2C E-commerce",
    services: ["Paid Media", "CRO"],
    metric: "ROAS",
    before: "1.8x",
    after: "6.2x",
    period: "in 6 months",
    summary: "Rebuilt the creative testing pipeline and landing system from scratch — scaled monthly spend 4x while efficiency tripled.",
  },
  {
    client: "Novabyte",
    industry: "B2B SaaS",
    services: ["SEO", "Content"],
    metric: "Organic pipeline",
    before: "$120k/qtr",
    after: "$890k/qtr",
    period: "in 3 quarters",
    summary: "Programmatic comparison pages plus digital PR turned organic search into the number-one pipeline channel.",
  },
  {
    client: "MediNest",
    industry: "Healthcare",
    services: ["Local SEO", "Paid Media"],
    metric: "Cost per booking",
    before: "₹2,140",
    after: "₹610",
    period: "in 90 days",
    summary: "Hyperlocal landing pages and call-tracked campaigns rolled out across 14 clinics with full compliance guardrails.",
  },
  {
    client: "FinchPay",
    industry: "Fintech",
    services: ["Analytics", "Paid Media"],
    metric: "CAC",
    before: "$86",
    after: "$39",
    period: "in 2 quarters",
    summary: "Server-side tracking and incrementality testing exposed 30% wasted spend — reallocated to channels that actually convert.",
  },
];
